module.exports = __webpack_public_path__ + "media/images/icons/media-pause-7d5a4f8203b009d47c7b51a7114db82b.svg";